import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {IconButton} from '@components/common/base/buttons'
import {cn} from '@containers/html-utils'

export const Window = ({children}: React.PropsWithChildren<unknown>) => {
  const bem = Util.bemFrom('notification-center', 'wnd')
  return <div className={bem()}>{children}</div>
}

export const WindowMain = ({children}: React.PropsWithChildren<unknown>) => {
  const bem = Util.bemFrom('notification-center', 'wnd', 'main')
  return <div className={bem()}>{children}</div>
}

export const WindowTitle = (
  props: React.PropsWithChildren<{newCount: number}>
) => {
  const bem = Util.bemFrom('notification-center', 'wnd')
  return (
    <div className={bem('title')}>
      {Lang.msg.notifications}
      {props.newCount > 0 && (
        <div className={bem('new-count')}>
          {Lang.msg.projectNewMessages(props.newCount)}
        </div>
      )}
      {props.children}
    </div>
  )
}

type TwIconButtonProps = React.ComponentProps<typeof IconButton> & {
  $alert?: boolean
}

const TwIconButton = tw<TwIconButtonProps>(IconButton)`
  -mx-4
  relative
  ${p =>
    cn(
      p.$alert &&
        cn(
          'after:content-[""]',
          'after:absolute',
          'after:w-4',
          'after:h-4',
          'after:rounded-full',
          'after:top-4',
          'after:right-4',
          'after:bg-error-l20'
        )
    )}
`

export const WindowContainer = ({
  onClick,
  alert,
  children
}: React.PropsWithChildren<{onClick(): void; alert: boolean}>) => {
  const bem = Util.bemFrom('notification-center')
  return (
    <div className={bem({alert})}>
      <TwIconButton
        icon="IconBell"
        onClick={onClick}
        color="panelIconSecondary"
        wrapperSize="big"
        size="small"
        $alert={alert}
      />
      {children}
    </div>
  )
}
